import {Box, Typography} from "@mui/material";

export default function Resume() {
    return (
        <Box padding={2}>
            <Typography variant="h1" >Resume</Typography>
            <Typography variant="body1" align="left">TODO</Typography>
        </Box>
    )
}